// extracted by mini-css-extract-plugin
export default {"conteudo":"Conteudo_conteudo__wFT+j"};